import type { IState } from 'redux/state';
import { createSelector } from 'reselect';
import type { Client } from 'types/client';
import { naturalSortBy } from 'utils/naturalSort';
import { enrichTicMeta } from 'utils/tic/enrichTicMeta';
import { keyBy } from 'utils/typesafe';

export const readClients = (state: IState) => state.clients.entries;

export const getClients = createSelector([readClients], (clients): Array<Client> => {
  return naturalSortBy(clients, client => client.name).map(enrichTicMeta);
});

/**
 * Returns normalized lookup object for all clients
 */
export const getClientEntities = createSelector(
  [getClients],
  (clients): Record<number, Client> => keyBy(clients, 'id')
);

export const getActiveClients = createSelector(
  [getClients],
  (clients): Array<Client> => clients.filter(client => client.active)
);

export const getArchivedClients = createSelector(
  [getClients],
  (clients): Array<Client> => clients.filter(client => !client.active)
);
